import {
  ADMIN_COOKIE_MAX_AGE_SECONDS,
  getCookie,
  removeCookie,
  setCookie,
} from "../Cookie";

const ADMIN_STORAGE_KEYS = {
  token: "__Token__",
  pass: "__Pass__",
  tmpToken: "__TmpToken__",
};

const CLIENT_STORAGE_KEYS = {
  profile: "__Profile__",
  tokenEncrypt: "__TokenEnCrypt__",
  tokenAsset: "__TokenAsset__",
  returnTo: "__ReturnTo__",
};

const STORAGE_KEYS = {
  ...ADMIN_STORAGE_KEYS,
  ...CLIENT_STORAGE_KEYS,
};

const ADMIN_COOKIE_OPTIONS = {
  maxAgeSeconds: ADMIN_COOKIE_MAX_AGE_SECONDS,
};

const PHONE_REVERIFICATION_STORAGE_KEY = "__PhoneReverification__";

const readJsonCookie = (key, defaultValue = null) => {
  try {
    const raw = getCookie(key);
    return raw ? JSON.parse(raw) : defaultValue;
  } catch {
    return defaultValue;
  }
};

const writeJsonCookie = (key, value, options) => {
  setCookie(key, JSON.stringify(value), options);
};

export const handleSetToken = (token) => {
  writeJsonCookie(STORAGE_KEYS.token, token, ADMIN_COOKIE_OPTIONS);
};
export const handleGetToken = () => {
  return readJsonCookie(STORAGE_KEYS.token);
};
// export const handleSetUserName = (userName) => {
//   writeJsonCookie(STORAGE_KEYS.userName, userName);
// };

// export const handleGetUserName = () => {
//   return readJsonCookie(STORAGE_KEYS.userName);
// };

export const handleSetPass = (pass) => {
  writeJsonCookie(STORAGE_KEYS.pass, pass, ADMIN_COOKIE_OPTIONS);
};

export const handleGetPass = () => {
  return readJsonCookie(STORAGE_KEYS.pass);
};

export const handleSetTokenEnCrypt = (token) => {
  writeJsonCookie(STORAGE_KEYS.tokenEncrypt, token);
};

export const handleSetTokenAsset = (token) => {
  writeJsonCookie(STORAGE_KEYS.tokenAsset, token);
};

export const handleGetTokenEnCrypt = () => {
  return readJsonCookie(STORAGE_KEYS.tokenEncrypt);
};

export const handleGetTokenAsset = () => {
  return readJsonCookie(STORAGE_KEYS.tokenAsset);
};

export const handleSetProfile = (data) => {
  writeJsonCookie(STORAGE_KEYS.profile, data);
};

export const handleGetProfile = () => {
  return readJsonCookie(STORAGE_KEYS.profile);
};

export const handleSetTmpToken = (token) => {
  writeJsonCookie(STORAGE_KEYS.tmpToken, token, ADMIN_COOKIE_OPTIONS);
};
export const handleGetTmpToken = () => {
  return readJsonCookie(STORAGE_KEYS.tmpToken);
};
export const handleRemoveTmpToken = () => {
  removeCookie(STORAGE_KEYS.tmpToken);
};
// export const handleSetUserPass = (data) => {
//   writeJsonCookie(STORAGE_KEYS.userPass, data);
// };

// export const handleGetUserPass = () => {
//   return readJsonCookie(STORAGE_KEYS.userPass);
// };

export const handleSetReturnTo = (returnTo) => {
  writeJsonCookie(STORAGE_KEYS.returnTo, returnTo);
};

export const handleGetReturnTo = () => {
  return readJsonCookie(STORAGE_KEYS.returnTo);
};

export const handleRemoveReturnTo = () => {
  removeCookie(STORAGE_KEYS.returnTo);
};

let verifiedClientUser = null;
let clientVerifyPromise = null;
let clientSessionReady = false;

export function getVerifiedClientUser() {
  return verifiedClientUser;
}

export function isClientSessionReady() {
  return clientSessionReady;
}

export function getClientVerifyPromise() {
  return clientVerifyPromise;
}

export function setClientVerifyPromise(promise) {
  clientVerifyPromise = promise;
}

export function rememberVerifiedClientUser(user) {
  verifiedClientUser = user?.AccountName ? user : null;
  clientSessionReady = true;
  clientVerifyPromise = Promise.resolve(verifiedClientUser);
  if (verifiedClientUser) writeJsonCookie(STORAGE_KEYS.profile, verifiedClientUser);
  notifyClientAuthChanged();
}

export const handleClearStoredAuth = () => {
  Object.values(CLIENT_STORAGE_KEYS).forEach((key) => removeCookie(key));
  verifiedClientUser = null;
  clientSessionReady = true;
  clientVerifyPromise = Promise.resolve(null);
  notifyClientAuthChanged();
};

export const handleGetPhoneReverificationState = (userName) => {
  if (!userName) return null;

  const records = readJsonCookie(PHONE_REVERIFICATION_STORAGE_KEY, {});
  return records?.[userName] || null;
};

export const handleSetPhoneReverificationState = (userName, state) => {
  if (!userName) return;

  const records = readJsonCookie(PHONE_REVERIFICATION_STORAGE_KEY, {});
  writeJsonCookie(PHONE_REVERIFICATION_STORAGE_KEY, {
    ...records,
    [userName]: state,
  });
};

/** True after get-user confirms a logged-in account. */
export const handleIsClientAuthenticated = () => {
  return Boolean(verifiedClientUser?.AccountName);
};

export const CLIENT_AUTH_CHANGED_EVENT = "vl:client-auth-changed";
export const OPEN_CLIENT_PROFILE_EVENT = "vl:open-client-profile";

export function notifyClientAuthChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CLIENT_AUTH_CHANGED_EVENT));
}

export function notifyOpenClientProfile() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_CLIENT_PROFILE_EVENT));
}
